module.exports = __webpack_public_path__ + "media/npc_dota_hero_sven.ba002be7.webm";